/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useLayoutEffect } from "react";
import { ChecklistDataGrid } from "../components/ChecklistDataGrid/ChecklistDataGrid";
import { TopMenuBar } from "../components/TopMenuBar/TopMenuBar";
import PackoutNameForm from "../components/PackoutNameForm/PackoutNameForm";
import ProgressBar from "../components/ProgressBar/ProgressBar";
import FilterIcon from "../components/FilterIcon/FilterIcon";
import FilterSideDrawer from "../components/FilterSideDrawer/FilterSideDrawer";
import NavBar from "../components/NavBar/NavBar";
import AddItems from "../components/AddItems/AddItems";
import AddItemsForm from "../components/AddItemsForm/AddItemsForm";

import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormHelperText from "@mui/material/FormHelperText";
import InputAdornment from "@mui/material/InputAdornment";
import CircularProgress from "@mui/material/CircularProgress";
import * as Utils from "../Utils";
import Button from "@mui/material/Button";
import * as XLSX from "xlsx";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";

import "./style.css";
import "@fontsource-variable/open-sans";
import SetPackingPreferencesModal from "../components/SetPackingPreferencesModal/SetPackingPreferencesModal"; 

let rows=[];

export const ChecklistPage = (props) => {
  const [db] = useState(props.database);
  const [scene] = useState(props.scene);
  const [dataFromChild, setDataFromChild] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsCounter, setRowsCounter] = useState([]);
  const [threshold, setThreshold] = useState(95);
  const [isDisabled, setIsDisabled] = useState(false);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilters, setIsFilters] = useState(false);
  const [NIINfilters, setNIINfilters] = useState([]);
  const [isAddItemsOpen, setIsAddItemsOpen] = useState(false);
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);
  const [packingPreferences, setPackingPreferences] = useState(null);

  let poplateCounter = 0;

  async function waitForSetRows() {
    const result = await Utils.getAllItemsFromEditStore();
    setRows(result ?? []);
    await timeout(1000);
    setRowsCounter(result ?? []);
  }

  async function waitForSetRowsdb(preferences) {
    const result = await Utils.getAllItemsFromEditStore();
    setRows(result ?? []);
    addBoxes(result, preferences);
  }

  async function handleDataFromChild(data) {
    setDataFromChild(data);
    console.log("child data returned");
  }

  async function addBoxes(results, preferences) {
    if (poplateCounter === 0) {
      Utils.addContainers(db).then(() => {
        console.log("Containers Added, calling createDistributedTable with preferences:", preferences);
        setIsLoading(true);
        Utils.createDistributedTable(parseInt(threshold) / 100, preferences).then(() => {
          console.log("distributed_items Added, calling placeBoxesOnPallet");
          window.location.href = "#/packingListPage";
        });
      });
      poplateCounter++;
    }
  }

  const downloadExcel = () => {
    const targetColumns = [
      "id",
      "box_id",
      "nsn",
      "niin",
      "nomenclature",
      "qty",
      "authorizedqty",
      "weight",
      "length",
      "width",
      "height",
      "palletid",
      "storagetype",
      "created_at",
      "updated_at",
      "ksn",
      "shopcode",
      "location",
    ];

    //Create a clean timestamp for the filename (e.g., ChecklistFile_20260625_123045.xlsx)
    const now = new Date();
    const dateStr = now.toISOString().slice(0, 10).replace(/-/g, "");
    const timeStr = now.toTimeString().slice(0, 8).replace(/:/g, "");
    const filename = `ChecklistFile_${dateStr}_${timeStr}.xlsx`;

    //Map the 'rows' state to match your exact column order and filter out extra data
    const formattedData = rows.map((row) => {
      const filteredRow = {};
      targetColumns.forEach((col) => {
        filteredRow[col] = row[col] !== undefined ? row[col] : "";
      });
      return filteredRow;
    });

    //Convert JSON data to sheet and enforce the column order
    const worksheet = XLSX.utils.json_to_sheet(formattedData, {
      header: targetColumns,
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Checklist");
    XLSX.writeFile(workbook, filename);
  };

  useLayoutEffect(() => {
    waitForSetRows();
  }, [2000]);

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  // Reactive evaluation of filtered data
  const filteredRows =
    NIINfilters.length === 0
      ? rows
      : rows.filter((row) =>
          NIINfilters.some((filter) =>
            row?.niin?.toLowerCase().includes(filter.toLowerCase()),
          ),
        );

  const handleApply = (filters) => {
    setNIINfilters(filters.niin);

    if (filters.niin.length === 0) {
      setIsFilters(false);
    } else {
      setIsFilters(true);
    }
  };

  // Handler to save new items from the modal
  const handleSaveNewItems = async (newItems) => {
    try {
      const itemsWithIds = await Utils.saveNewItemsAPI(newItems);

      if (!Array.isArray(itemsWithIds)) {
        throw new Error("Received an invalid response from the server.");
      }

      const updatedRows = [...rows, ...itemsWithIds];
      setRows(updatedRows);
      setRowsCounter(updatedRows);
      await Utils.updateItemsInEditStore(updatedRows);

      setIsAddItemsOpen(false);
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  };

  async function waitHandler(preferences) {
    db.emptySomeBoxes();
    await waitForSetRowsdb(preferences);
  }

  const handleOnNextStep = (e) => {
    if (isDisabled) return;
    e.preventDefault();
    setIsPreferencesOpen(true);
  };

  const handlePreferencesConfirm = (modalData) => {
    setPackingPreferences(modalData);
    setIsPreferencesOpen(false);     // Close the modal
    setIsDisabled(true);             // Disable button as original logic did

    // Pass the modal data directly (state updates are async, so reading
    // packingPreferences here would still see null).
    waitHandler(modalData);          // Continue with next step execution
  };

  const handleTextFieldChange = (e) => {
    setThreshold(e.target.value);
  };

  return (
    <div className="checklist">
      <SetPackingPreferencesModal
        open={isPreferencesOpen}
        onClose={() => setIsPreferencesOpen(false)}
        onConfirm={handlePreferencesConfirm}
      />
      <AddItems
        open={isAddItemsOpen}
        onClose={() => setIsAddItemsOpen(false)}
        title="Add New Items to Checklist"
        maxWidth="800px"
      >
        <AddItemsForm
          onSave={handleSaveNewItems}
          onCancel={() => setIsAddItemsOpen(false)}
        />
      </AddItems>
      <FilterSideDrawer
        isOpen={openPanel}
        onClose={() => setOpenPanel(false)}
        onApply={handleApply}
        defaultNiin={NIINfilters}
      />
      <TopMenuBar />
      <div className="under-banner">
        <ProgressBar page="checklist"></ProgressBar>
        <div className="div">
          <div className="frame-2">
            <div className="frame-3">
              {isLoading ? (
                <div className="loading-overlay">
                  <CircularProgress />
                  <p>Loading Data, please wait...</p>
                </div>
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Restored the ".name-form" and added the "Add Items" button next to the filter icon */}
                  <div
                    className="name-form"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div className="left-side">
                      <PackoutNameForm />
                      <p className="directions">
                        <span className="p-bold">
                          2. Review your packing list.
                        </span>{" "}
                        Below is a summary of the list you uploaded. Dimensions
                        are in pounds and inches.
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <IconButton
                        onClick={() => {
                          downloadExcel();
                        }}
                        aria-label="download"
                        className="download-btn"
                        size="large"
                      >
                        <DownloadIcon />
                      </IconButton>
                      <Button
                        className="additional-items"
                        onClick={() => setIsAddItemsOpen(true)}
                      >
                        Add Items +
                      </Button>
                      <FilterIcon
                        onClick={() => setOpenPanel(true)}
                        inUse={isFilters}
                      />
                    </div>
                  </div>
                  <div style={{ flex: 1, minHeight: 0, paddingTop: "1rem" }}>
                    <ChecklistDataGrid
                      sendDataToParent={handleDataFromChild}
                      rowsCounter={rowsCounter}
                      rows={filteredRows} 
                      scene={scene}
                      onRowDataChange={(updatedRowsFromGrid) => setRows(updatedRowsFromGrid)} // Added a callback to let grid update parent data
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <NavBar>
            <FormControl variant="outlined">
              <OutlinedInput
                id="outlined-adornment-weight"
                defaultValue="95"
                endAdornment={<InputAdornment position="end">%</InputAdornment>}
                aria-describedby="outlined-weight-helper-text"
                inputProps={{
                  "aria-label": "percent",
                }}
                onChange={handleTextFieldChange}
              />
              <FormHelperText id="outlined-weight-helper-text">
                Support Threshold
              </FormHelperText>
            </FormControl>
            <button className="button-10">
              <Button className="button-11" disabled={isDisabled} onClick={handleOnNextStep}>
                Next Step
              </Button>
            </button>
          </NavBar>
        </div>
      </div>
    </div>
  );
};

export default ChecklistPage;